<div fxLayoutGap="24px" fxLayout="column" fxLayoutAlign="start center" mat-dialog-content>

  <img src="../../assets/images/logos/ls-premium.png" alt="Little SIS Premium Logo" class="logo">

  <div fxLayout="column" fxLayoutAlign="start center">
    <div fxLayout="row" class="license-info-panel red-600-fg" fxLayoutAlign="center center" fxLayoutGap="16px">
      <mat-icon class="icon-20">warning</mat-icon>
      <p>{{templateData.expiryMessage}}</p>
    </div>
    <button class="renew-button" mat-raised-button (click)="openHelpCenter()">LEARN MORE</button>
  </div>

  <div fxLayout="column" fxLayoutAlign="start center">
    <p class="license-info-panel">
      Did you want a free trial? If so, please press the button below to start.
    </p>
    <button class="renew-button" mat-raised-button (click)="requestTrial()">FREE TRIAL INQUIRY</button>
  </div>

</div>

<div fxLayoutAlign="space-between center" mat-dialog-actions>
  <span class="small-strong">** If you have already had a free trial, you will not be able to start another.</span>
  <button mat-raised-button class="grey-button" (click)="logout()">LOGOUT</button>
</div>


